import React, { useCallback, useEffect, useState } from 'react';
import { Collapse, Button } from '@material-ui/core';
import { useMenuStyles } from 'shared/components/verticalMenu/styles';
import { TMenuCategoryChild } from 'shared/models/Global';
import { VerticalMenuItem } from 'shared/components/verticalMenu/VerticalMenuItem';

interface IVerticalMenuItemsProps {
    menuItems: TMenuCategoryChild[];
    isMinimized: boolean;
}

export const VerticalMenuItems = ({ menuItems, isMinimized }: IVerticalMenuItemsProps) => {
    const classes = useMenuStyles();
    const [menuExpanded, setMenuExpanded] = useState(false);
    const nonCollapseItemsMaxCount = 9;
    const nonCollapsable = menuItems.slice(0, nonCollapseItemsMaxCount);
    const collapsable = menuItems.slice(nonCollapseItemsMaxCount);

    useEffect(() => {
        if (isMinimized) {
            setMenuExpanded(false);
        }
    }, [isMinimized, setMenuExpanded]);
    const onMoreBtnClick = useCallback(event => {
        event.stopPropagation();
        setMenuExpanded(!menuExpanded);
    }, [setMenuExpanded, menuExpanded]);

    return (
        <>
            {nonCollapsable.map(menuItem => (
                <VerticalMenuItem
                    key={menuItem.id || menuItem.title}
                    menuItem={menuItem}
                    isMinimized={isMinimized}
                />))}
            {collapsable.length > 0 && (
                <>
                    <Collapse
                        in={menuExpanded}
                        timeout="auto"
                        unmountOnExit
                    >
                        {collapsable.map(menuItem => (
                            <VerticalMenuItem
                                key={menuItem.id || menuItem.title}
                                menuItem={menuItem}
                                isMinimized={isMinimized}
                            />
                        ))}
                    </Collapse>
                    {!isMinimized && (
                        <Button
                            className={classes.expandMenuButton}
                            onClick={onMoreBtnClick}
                            disableRipple
                        >
                            {menuExpanded ? 'Show less' : 'Show more'}
                        </Button>
                    )}
                </>
            )}
        </>
    );
};
